exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* Grays */\n  --gray-50: #f5f5f5;\n  --gray-100: #E6E6E6;\n  --gray-200: #CCCCCC;\n  --gray-300: #949494;\n  --gray-400: #6F6F6F;\n  --gray-500: #333333;\n  --gray-600: #0A0A0A;\n  \n  /* Amber colors */\n  --amber-100: #fff1c7;\n  --amber-200: #ffe69c;\n  --amber-300: #ffc107;\n  --amber-400: #f59e0b;\n}\n", ""]);

// exports
